import React from "react";
import styled from "styled-components";
import { Sort, Check } from "@material-ui/icons";
import Button from "@material-ui/core/Button";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router";
import Wrapper from "../atoms/Wrapper";
import ClipStream from "./ClipStream";
import {
  get_vtubers_clips,
  reset_vtubers_clips,
  set_vtubers_clips_order,
} from "../../actions/vtuber";
import FloatingActionButton from "./FloatingActionButton";

const StyledWrapper = styled(Wrapper)`
  flex-direction: column;
  width: 95%;
  align-items: flex-start;
  box-sizing: border-box;

  @media (max-width: 450px) {
    width: 100%;
  }
`;

const SortButton = styled(Button)`
  color: ${(props) => props.theme.colors.black100} !important;
`;

const StyledSortIcon = styled(Sort)`
  color: ${(props) => props.theme.colors.gray};
  margin-right: 0.4rem;
`;

const SortPanel = styled(Wrapper)`
  flex-direction: column;
  width: 100%;
`;

const SortOptionWrapper = styled(Wrapper)`
  margin-top: 0.3rem;
  width: 100%;
`;

const SortOption = styled(Button)`
  width: 100%;
  color: ${(props) =>
    props.selected
      ? props.theme.colors.black
      : props.theme.colors.gray} !important;
  ${(props) =>
    props.selected
      ? `background: ${props.theme.colors.gray100} !important;`
      : ""}
`;

const SortWrapper = styled(Wrapper)`
  width: 100%;
  flex-direction: column;
  margin: 0.4rem 0 0.7rem 0px;
  align-items: flex-start;
  padding: 0 0.5rem;
`;

const CheckIconWrapper = styled(Wrapper)`
  margin-left: 0.5rem;
`;

const VTubersClipStream = (props) => {
  const dispatch = useDispatch();
  const { page, state, items, has_more } = useSelector(
    (state) => state.vtuber.clips
  );
  const loadMore = (page) => {
    dispatch(get_vtubers_clips(props.name)(page));
  };
  const handle_new = () => {
    props.history.push("/forum/clips/new");
  };
  const [sort_expanded, set_sort_expanded] = React.useState(false);
  const handle_click = () => {
    set_sort_expanded((old) => !old);
  };
  const [sort_option_selected, set_sort_option_selected] = React.useState(0);
  const options = ["新しい順", "いいね順"];
  const options_query_params = ["created_at", "likes"];
  const handle_option_click = (idx) => () => set_sort_option_selected(idx);

  const [
    first_order_change_avoid_flg,
    set_first_order_change_avoid_flg,
  ] = React.useState(false);

  React.useEffect(() => {
    if (first_order_change_avoid_flg) {
      dispatch(
        set_vtubers_clips_order(options_query_params[sort_option_selected])
      );
      dispatch(reset_vtubers_clips());
    }
    set_first_order_change_avoid_flg(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sort_option_selected]);

  React.useEffect(() => {
    return () => {
      dispatch(reset_vtubers_clips());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    dispatch(reset_vtubers_clips());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.name]);

  return (
    <StyledWrapper>
      <SortWrapper>
        <SortButton onClick={handle_click}>
          <StyledSortIcon />
          並べ替え
        </SortButton>
        {sort_expanded && (
          <SortPanel>
            {options.map((option, idx) => (
              <SortOptionWrapper>
                <SortOption
                  onClick={handle_option_click(idx)}
                  selected={sort_option_selected === idx}
                >
                  {option}
                  {sort_option_selected === idx && (
                    <CheckIconWrapper>
                      <Check />
                    </CheckIconWrapper>
                  )}
                </SortOption>
              </SortOptionWrapper>
            ))}
          </SortPanel>
        )}
      </SortWrapper>
      {props.name && (
        <ClipStream
          items={items}
          loadMore={loadMore}
          page={page}
          hasMore={has_more}
          requestState={state}
        />
      )}
      <FloatingActionButton onClick={handle_new} tooltip="Clipの新規作成" />
    </StyledWrapper>
  );
};

export default withRouter(VTubersClipStream);
